//
// Copyright (c) 2011-2018 by Curalate, Inc.
//

/* eslint-disable import/no-unresolved */
import {
  IModalInstanceService,
  IModalService,
  IModalSettings,
} from 'angular-ui-bootstrap';
/* eslint-enable import/no-unresolved */

import getAngularInjector from '../getAngularInjector';

const ANGULAR_MODAL_SERVICE_NAME = '$modal';

export function openAngularModal(
  options: IModalSettings,
): IModalInstanceService {
  const angularModalService: IModalService = getAngularInjector().get(
    ANGULAR_MODAL_SERVICE_NAME,
  );
  return angularModalService.open(options);
}
